<template src="./GoodsAdd.html"></template>

<script>
    import goodsTopMenu from "@/components/goods/components/topMenu";
    import {createNamespacedHelpers} from "vuex";

    const { mapGetters} = createNamespacedHelpers('goods/handler');
    const MULTI_LANG_FIELD = [
      'description',
      'type',
      'characteristic',
      'template_description',
      'short_description',
      'uniqueCharacteristics',
      'uniqueDescriptions',
    ]
    const SKELETON = {
        'name': '',
        'article': '',
        'brand': '',
        'photos': [],
        'category': '',
        'donor_name': '',
        'donor_link': '',
        'link': '',
        'tags': '',
        'search_query': '',

        'price': '',
        'currency': '',
        'customs_number': '',
        'EAN': '',

        'weight': '',
        'dimension': '',// value
        'dimension_type': '',// pieces - 1 // weight - 2 // length - 3 // volume - 4
        'pdfs_1': [],
        'pdfs_2': [],
        'pdfs_3': [],
        'pdfs_4': [],

        'additional_1': '',
        'additional_2': '',
        'additional_3': '',

        'parent-name': '',
        'parentStatus-name': '',
        'seoFlag': false,
    };

    const PARENT_STATUS = [
      { value: '2', text: 'родительский' },
      { value: '1', text: 'дочерний' },
      { value: '0', text: 'неопределенный' },
    ]

    export default {
        name: "goods-add",
        components: {
            goodsTopMenu
        },
        data() {
            return {
                product: {},
                langList: ['ru', 'en', 'de', 'es', 'it', 'fr'],
                currentLang: 'ru',
                dimensionType: [1, 2, 3, 4],
                numberPromptItem: 10,
                brandPromptList: [],
                sendTimer: null,
                isPromptBoxHover: false,
                isBrandInputFocus: false,
                photoNumber: 1,
                isLoad: false,
                duplicateText: '',
                duplicateRewrite: false,
                parentStatus: PARENT_STATUS,
            }
        },
        methods: {
            onSubmit(evt) {
                evt.preventDefault()
                this.sendForm();
            },
            sendForm() {
                let formData = new FormData();
                var th = this
                for (let key in this.product.photos) {
                    formData.append('photo_'+ key, this.product.photos[key]);
                }
                for (let key in this.product) {
                    formData.append(key, this.product[key]);
                }
                formData.append('lang', this.currentLang);
                formData.append('duplicateRewrite', this.duplicateRewrite);

                this.isLoad = true;
                this.$store.dispatch('SEND_POST', {
                    url: '/goods-add',
                    parameter: formData,
                    config: {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    },
                    th: th,
                    getSuccessResponse: (data) => {
                        if (data == 7) {
                            console.log(data);
                        }
                        th.product = Object.assign({}, this.skeleton);
                        th.product.photos = [];
                        th.photoNumber = 1;
                    },
                    getResponse: () => {
                        th.isLoad = false;
                    },
                    getHandleError: (errorInfo) => {
                        if (errorInfo !== undefined && errorInfo.indexOf('{duplicate}') != -1) {
                            th.duplicateText = errorInfo.replace('{duplicate}', '');
                            th.$bvModal.show('duplicateMessage');
                        } else {
                            th.$store.commit('setErrorText', errorInfo);
                            th.$bvModal.show('errorResponse');
                        }
                    }
                });
            },
            brandInput() {
                console.log(this.product.brand)
                if (this.product.brand.length < 2) {
                    return
                }
                var th = this
                var sendRequest = function () {
                    console.log(th.isBrandInputFocus);
                    if (!th.isBrandInputFocus) {
                        return;
                    }
                    th.$store.dispatch('SEND_GET', {
                        url: '/brand-name?sort=name&sortDir=asc&name='+ th.product.brand +'&page=1&pageSize='+
                            th.numberPromptItem,
                        th: th,
                        getSuccessResponse: (data) => {
                            if (!th.isBrandInputFocus) {
                                return;
                            }
                            th.brandPromptList = []
                            for (let key in data.data) {
                              th.brandPromptList.push(data.data[key].name)
                            }
                            th.$refs.promptBox.style.display = 'block';
                        },
                        showSuccessMessage: false
                    })
                }
                if (this.sendTimer != null) {
                    clearTimeout(this.sendTimer);
                }
                this.sendTimer = setTimeout(() => {sendRequest()}, 1000);
            },
            brandSelect(brandName) {
                this.product.brand = brandName;
                this.$refs['promptBox'].style.display = 'none';
            },
            hidePromptBox() {
                if (!this.isPromptBoxHover) {
                    this.$refs['promptBox'].style.display = 'none';
                }
            },
            handleOk() {
                this.duplicateRewrite = true;
                this.sendForm();
                this.duplicateRewrite = false;
                this.$bvModal.hide('duplicateMessage');
            }
        },
        computed: {
            ...mapGetters([
                'BRAND_LIST'
            ]),
          skeleton() {
            let skeleton = Object.assign({}, SKELETON)
            for (let key in MULTI_LANG_FIELD) {
              for (let key2 in this.langList) {
                let fieldName = MULTI_LANG_FIELD[key]
                let lang = this.langList[key2]
                skeleton[fieldName +'-'+ lang] = ''
              }
            }

            return skeleton
          }
        },
      created() {
        this.product = Object.assign({}, this.skeleton)
      },
    }
</script>

<style scoped>
    div.form-group {
        float: left;
    }
    .field-line {
        float: none;
    }
    .big-desc-textarea textarea {
        height: 15em;
        width: 30em;
    }
    .big-uniq-desc-textarea textarea {
        height: 15em;
        width: 57em;
    }
    .small-desc-textarea textarea {
        height: 6em;
        width: 35em;
    }
    .lang-select {
        width: 4em;
    }
    .prompt-box {
        position: absolute;
        z-index: 1000;
        background-color: white;
        border: solid;
        border-color: rgb(206, 212, 218);
        border-width: 1px;
        padding: 1em 0 1em;
        margin: 0.2em;
        margin-left: -0.2em;
        text-align: left;
        box-shadow: 0 8px 10px 2px grey;
    }
    .prompt-item:hover {
        border: 2px solid;
        background-color: #007bff;
    }
    .prompt-item {
        padding: 0 1em 0 1em;
        /*width: 105px;*/
        overflow: hidden;
        border: 2px solid #ffffff;
    }
    .photos-col {
        overflow-y: scroll;
        height: 224px;
    }
    .photos-input, .document-input {
        overflow: hidden;
    }
</style>

<style>
    label {
        text-align: left;
    }
    .document-container div[role="group"] > label {
        float: left;
        line-height: 2.5em;
        margin: 0;
        margin-right: 1em;
    }
    .document-container div[role="group"] > div {
        float: right;
    }
    .document-container input.custom-file-input {
        width: 560px!important;
    }
    .photos-col .custom-file {
        width: 560px!important;
    }
</style>